<div class="queue-menu-item queue-selectable-primary noselect"
     [ngClass]="{ 'inactive': input.inactivePredicate(), 'active': input.activePredicate(), 'queued': input.queuedPredicate() }"
     (click)="input.onClick()"
>
  <mat-icon
    class="ami-drag-handle"
    cdkDragHandle
    matTooltip="Drag to reorder"
    matTooltipPosition="above"
    (click)="$event.stopPropagation()"
  >
    drag_indicator
  </mat-icon>

  <div class="ami-icon-and-title">
      <mat-icon class="ami-icon"
                [style.color]="input.iconColor"
      >
          {{ input.icon }}
      </mat-icon>
      <div class="ami-title">
          {{ input.title }}
      </div>
  </div>

  <div class="ami-subtitle-and-action">
    @if (input.queuedPredicate()) {
      <button
        mat-icon-button
        class="ami-delete-btn"
        matTooltip="Remove from queue"
        (click)="onDeleteClick($event)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    }
    @if (input.subtitle) {
      <div class="ami-subtitle"
      >
        {{ input.subtitle }}
      </div>
    }
  </div>
</div>
